﻿import { JSXElement } from 'solid-js';
import CustomTooltip from '../CustomTooltip/CustomTooltip';
import IconButton from '../IconButton/IconButton';
import { BtnClasses } from '../../types/common';
import Icon from '../Icon/Icon';

export interface MultiListItemProps<Item> {
  listItem: Item;
  index: number;
  getName(item: Item): string;
  onClick?(index: number): void;
  onRemove?(index: number): void;
  getThumbnail?(item: Item): JSXElement;
}

function MultiListItem<Item>(props: MultiListItemProps<Item>): JSXElement {
  return (
    <li class="list-item group">
      <div class="group-items px-0">
        {props.getThumbnail ? (
          /* eslint-disable-next-line custom/no-direct-solid-component-invocation -- Tracked by https://jira.trimble.tools/browse/TWENG-38 */
          props.getThumbnail(props.listItem)
        ) : (
          <Icon icon="tc-icon-release" size="icon-small" />
        )}
        <CustomTooltip text={props.getName(props.listItem)} position="left">
          <span class="block" onClick={() => props.onClick?.(props.index)}>
            {' '}
            {props.getName(props.listItem)}
          </span>
        </CustomTooltip>
        <IconButton
          icon="tc-icon-content-close"
          color={BtnClasses.Tertiary}
          shape="icon-circle"
          clicked={() => props.onRemove?.(props.index)}
        />
      </div>
    </li>
  );
}

export default MultiListItem;
